module.exports = __webpack_public_path__ + "static/media/villager.8528ccb0.jpg";